// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__fshGK","section-1":"styles_section-1__7ep-D","content":"styles_content__cZWCG","section-2":"styles_section-2__NYk2n"};